import { useMemo, useRef } from 'react';
import { ChatWidget } from '@ampersandbrands/ui';
import { createChatClient } from '@/lib/chatClient';
import { useEffectiveStoreNo, useStoreMe } from '@/lib/useStores';

// Floating chat on every authed page. The shared ChatWidget renders the bubble
// and panel; this wrapper supplies Sweet Spot's data client and resolves the
// caller's store channel so the Ask HQ button/mode targets the right store
// (HQ / dual-role users use the store selected in the header; store users use
// their own mapped store). The higher fab offset clears the bottom nav.
export function ChatBubble() {
  const effectiveStoreNo = useEffectiveStoreNo();
  const me = useStoreMe(effectiveStoreNo);
  const storeNo = effectiveStoreNo ?? me.data?.store?.store_no;
  // The client is memoized once; the ref keeps its store lookup current so
  // Ask Amp always queries the store selected at ask time.
  const storeNoRef = useRef<string | number | null | undefined>(storeNo);
  storeNoRef.current = storeNo;
  const client = useMemo(() => createChatClient(() => storeNoRef.current), []);
  const askHqChannelKey = storeNo != null ? `store:${storeNo}` : null;

  return (
    <ChatWidget
      client={client}
      askHqChannelKey={askHqChannelKey}
      fabClassName="bottom-[calc(3.5rem+1rem+env(safe-area-inset-bottom,0px))] right-4"
    />
  );
}
